import { createInjectionState } from "@vueuse/shared";
import { ref } from "vue";

const DURATION = 3000;

const [useProvideToast, _useToast] = createInjectionState(() => {
	const index = ref(0);
	const toasts = ref([]);

	function addToast(type, message) {
		const id = index.value;
		const timeout = setTimeout(() => removeToast(id), DURATION + 300);
		const toastData = {
			id,
			type,
			message,
			timeout,
		};
		toasts.value.push(toastData);
		index.value += 1;
	}

	function removeToast(toastId) {
		const toastIndex = toasts.value.findIndex((item) => item.id === toastId);
		if (toastIndex > -1) {
			clearTimeout(toasts.value[toastIndex].timeout);
			toasts.value.splice(toastIndex, 1);
		}
	}

	return {
		toast: {
			success: (message) => addToast("success", message),
			error: (message) => addToast("error", message),
		},
		removeToast,
		toasts,
	};
});

export { useProvideToast };

export function useToast() {
	const store = _useToast();
	if (store == null)
		throw new Error(
			"Please call `useProvideToast` on the appropriate parent component"
		);
	return store;
}
